// crypto
import CryptoJS from 'crypto-js';

// map
const fileHashMap = {};

/**
 * calculateHash
 * @param {*} file
 * @returns
 */
export const calculateHash = (file, onCalcHashEnd) => {
  const methodName = 'calculateHash';

  return new Promise((resolve, reject) => {
    // const
    const chunkSize = 1024 * 1024; // 1MB chunks
    const fileSize = file.size;
    const chunks = Math.ceil(fileSize / chunkSize);
    const fileTag = file.name + file.size;
    console.info(methodName, 'chunkSize', chunkSize);
    console.info(methodName, 'fileSize', fileSize);
    console.info(methodName, 'chunks', chunks);
    console.info(methodName, 'fileTag', fileTag);

    // cache
    if (fileHashMap[fileTag]) {
      const hash = fileHashMap[fileTag];
      console.info(methodName, 'cache', fileTag);
      console.info(methodName, 'hash', hash);

      if (onCalcHashEnd) onCalcHashEnd(hash);
      return resolve(fileHashMap[fileTag]);
    }

    // reader
    let currentChunk = 0;
    const hash = CryptoJS.algo.SHA256.create();
    const reader = new FileReader();
    reader.onload = function (event) {
      hash.update(CryptoJS.lib.WordArray.create(event.target.result));
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        console.info(methodName, 'end');
        const hex = hash.finalize().toString(CryptoJS.enc.Hex);
        fileHashMap[fileTag] = hex;

        if (onCalcHashEnd) onCalcHashEnd(hex);
        resolve(hex);
      }
    };
    reader.onerror = function () {
      console.info(methodName, 'error');

      if (onCalcHashEnd) onCalcHashEnd();
      reject('Unable to calculate hash');
    };

    function loadNext() {
      console.info(methodName, 'loadNext');
      const start = currentChunk * chunkSize;
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      reader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNext();
  });
};
